/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PaginatedTagListList } from '../models/PaginatedTagListList';
import type { PaginatedTagWriteSerializerWithReprList } from '../models/PaginatedTagWriteSerializerWithReprList';
import type { PatchedTagWriteSerializerWithRepr } from '../models/PatchedTagWriteSerializerWithRepr';
import type { TagRead } from '../models/TagRead';
import type { TagWriteSerializerWithRepr } from '../models/TagWriteSerializerWithRepr';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class TagsService {
    /**
     * @returns PaginatedTagListList
     * @throws ApiError
     */
    public static tagsList({
        category,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        category?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedTagListList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tags/',
            query: {
                'category': category,
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
        });
    }
    /**
     * @returns TagWriteSerializerWithRepr
     * @throws ApiError
     */
    public static tagsCreate({
        requestBody,
    }: {
        requestBody: TagWriteSerializerWithRepr,
    }): CancelablePromise<TagWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tags/',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedTagWriteSerializerWithReprList
     * @throws ApiError
     */
    public static tagBulkUpdate({
        requestBody,
        category,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<TagWriteSerializerWithRepr>,
        category?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedTagWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tags/',
            query: {
                'category': category,
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns PaginatedTagWriteSerializerWithReprList
     * @throws ApiError
     */
    public static tagBulkPartialUpdate({
        requestBody,
        category,
        excludeFields,
        fields,
        limit,
        name,
        offset,
        ordering,
        readDepth,
        search,
    }: {
        requestBody: Array<TagWriteSerializerWithRepr>,
        category?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        /**
         * Number of results to return per page.
         */
        limit?: number,
        name?: Array<string>,
        /**
         * The initial index from which to return the results.
         */
        offset?: number,
        /**
         * Which field to use when ordering the results.
         */
        ordering?: string,
        readDepth?: number,
        /**
         * A search term.
         */
        search?: string,
    }): CancelablePromise<PaginatedTagWriteSerializerWithReprList> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tags/',
            query: {
                'category': category,
                'exclude-fields': excludeFields,
                'fields': fields,
                'limit': limit,
                'name': name,
                'offset': offset,
                'ordering': ordering,
                'read_depth': readDepth,
                'search': search,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static tagBulkDestroy({
        id,
    }: {
        id?: Array<number>,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tags/',
            query: {
                'id': id,
            },
        });
    }
    /**
     * @returns TagRead
     * @throws ApiError
     */
    public static tagsRetrieve({
        id,
        category,
        excludeFields,
        fields,
        name,
        readDepth,
    }: {
        /**
         * A unique integer value identifying this tag.
         */
        id: number,
        category?: Array<string>,
        excludeFields?: Array<string>,
        fields?: Array<string>,
        name?: Array<string>,
        readDepth?: number,
    }): CancelablePromise<TagRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tags/{id}/',
            path: {
                'id': id,
            },
            query: {
                'category': category,
                'exclude-fields': excludeFields,
                'fields': fields,
                'name': name,
                'read_depth': readDepth,
            },
        });
    }
    /**
     * @returns TagWriteSerializerWithRepr
     * @throws ApiError
     */
    public static tagsUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tag.
         */
        id: number,
        requestBody: TagWriteSerializerWithRepr,
    }): CancelablePromise<TagWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/tags/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns TagWriteSerializerWithRepr
     * @throws ApiError
     */
    public static tagsPartialUpdate({
        id,
        requestBody,
    }: {
        /**
         * A unique integer value identifying this tag.
         */
        id: number,
        requestBody?: PatchedTagWriteSerializerWithRepr,
    }): CancelablePromise<TagWriteSerializerWithRepr> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/tags/{id}/',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static tagsDestroy({
        id,
    }: {
        /**
         * A unique integer value identifying this tag.
         */
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/tags/{id}/',
            path: {
                'id': id,
            },
        });
    }
}
